module.exports = __webpack_public_path__ + "static/media/5.d3f5c2e8.jpg";